<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.userCategory.form.name')" prop="name" >
        <a-input v-model="form.name" :placeholder="$t('views.userCategory.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.userCategory.form.nameEn')" prop="nameEn" >
        <a-input v-model="form.nameEn" :placeholder="$t('views.userCategory.form.nameEnPlaceholder')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.userCategory.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.userCategory.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCategory, addCategory, updateCategory } from '@/api/user/category'

export default {
  name: 'CreateForm',
  props: {
  },
  data () {
    return {
      submitLoading: false,
      // 表单参数
      form: {
        id: null,

        name: null,

        nameEn: null,

        parentId: null,

        level: null,

        path: null,

        icon: null,

        description: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1
        ? this.$t('views.userCategory.title.add')
        : this.$t('views.userCategory.title.edit')
    },
    rules () {
      return {
        name: [
          { required: true, message: this.$t('views.userCategory.rule.nameRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        nameEn: null,
        parentId: null,
        level: null,
        path: null,
        icon: null,
        description: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCategory({ id }).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.userCategory.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.userCategory.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.userCategory.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.userCategory.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
